// src/store/thunks/administrators/forceLoginResetAdminThunk.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';

// eslint-disable-next-line @typescript-eslint/no-invalid-void-type -- void
export const forceLoginResetAdminThunk = createAdminAsyncThunk<void, { id: string }>(
  'administrators/forceLoginReset',
  async({ id }, { extra: { administratorsService } }) => {
    await administratorsService.forceLoginReset(id);
  }
);
